<template>
  <v-form ref="form" class="mt-3 mx-3">
    
    <BaseUtil
      ref="util"
      :pageLoading="pageLoading"
    />

    <v-row>
      <v-col cols="12" sm="10" md="8">
        <v-text-field
          v-model="entry.description"
          v-bind="getObject('description')"
          label="Descrição"
          autocomplete="off"
          :disabled="readOnly"
        />
      </v-col>

      <v-col cols="12" sm="6" md="4">
        <v-autocomplete
          v-model="entry.kind"
          v-bind="getObject('kind')"
          label="Tipo"
          :items="extraData.accountContext.allTablePriceKinds"
          item-value="id"
          item-text="name"
          autocomplete="off"
          :disabled="readOnly"
        >
        </v-autocomplete>
      </v-col>

      <v-col cols="12" sm="6" md="6">
        <v-autocomplete
          v-model="entry.personType"
          v-bind="getObject('personType')"
          label="Tipo de pessoa"
          :items="extraData.accountContext.allTablePricePersonTypes"
          item-value="id"
          item-text="name"
          autocomplete="off"
          :disabled="readOnly"
        >
        </v-autocomplete>
      </v-col>

    </v-row>
  </v-form>
</template>

<script>
import MaskedTextField from "@shared_components/masked_text_field.vue"
import gql from 'graphql-tag'
import CultureNew from "@models/cultures/new.vue"
import BaseUtil from "@shared_components/base_util.vue"

export default {
  data() {
    return {
      entryAttributes: {},
      packagingsListLoading: false,
      packagingsList: [],
      packagingsListKey: 0,
      pageLoading: false,
    };
  },
  props: {
    entry: Object,
    extraData: Object,
    readOnly: {
      type: Boolean,
      default: false
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    modelNameSingular: String,
  },
  components: {
    MaskedTextField: MaskedTextField,
    CultureNew: CultureNew,   
    BaseUtil: BaseUtil,
  },
  created() {
    this.entryAttributes = this.setupEntryAttributes(this.entry);
  },
  mounted() {
    // if (this.entry.unitId) {
    //   this.getPackagingsForUnit(false);
    // }
  },
  methods: {
    getObject: function(element, component) {
      return this.entryAttributes[element];
    },
    isFormValid: function() {
      if (this.$refs.form.validate()) {
        return true;
      } else {
        setTimeout(function(){
          document.querySelector(".v-messages.error--text:first-of-type").scrollIntoView({ behavior: 'smooth', block: 'center' });
        }, 500);
      }
      return false;
    },
    resetFormInputs: function() {
      this.$refs.form.resetValidation();
    },      
    cultureCreated: function(culture) {
      this.extraData.adminContext.allCultures.unshift(culture);
      this.entry.cultureId = culture.id;
      this.entry.culture = culture;
    },
  }
};
</script>

<style scoped></style>
